import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

interface HelpSearchBoxProps {
	value: string;
	onChange: (value: string) => void;
	/** The box's accessible name, as there's no visible label. */
	label: string;
	placeholder: string;
	/** `hero` is the landing page's large pill; `compact` sits in a page header. */
	size?: "hero" | "compact";
}

/** A pill-shaped search box, as on Engage's Help Centre. */
function HelpSearchBox({
	value,
	onChange,
	label,
	placeholder,
	size = "compact",
}: Readonly<HelpSearchBoxProps>) {
	return (
		<div role="search" className={`help-search help-search--${size}`}>
			<Input
				value={value}
				onChange={(event) => onChange(event.target.value)}
				aria-label={label}
				placeholder={placeholder}
				prefix={<SearchOutlined aria-hidden="true" />}
				allowClear
				size={size === "hero" ? "large" : "middle"}
			/>
		</div>
	);
}

export default HelpSearchBox;
